import React from 'react'
import { Container } from 'reactstrap'

const PrivacyPolicy = () => {
    return (
        <Container>
            <h2 className="mb-4">Privacy Policy</h2>
            <p className="mb-4">
                Last updated: {new Date().toLocaleDateString()}
            </p>

            <div>
                <h5 className='text-primary'>
                    Introduction
                </h5>
                <p className='ms-3'>
                    The UN Global Compact Network South Africa ("UNGCNSA") is committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our SME and Supplier ESG Readiness Tool ("the Tool").
                </p>
                <p className='ms-3'>
                    This policy complies with the Protection of Personal Information Act (POPIA) of South Africa and other applicable data protection laws. By using the Tool, you consent to the practices described in this policy.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Information We Collect
                </h5>
                <p className='ms-3'>
                    1.1 Personal Information:
                    <ul className='ms-4'>
                        <li>Name and contact details (email address, phone number)</li>
                        <li>Company information and registration details</li>
                        <li>Account credentials</li>
                        <li>Assessment responses and submissions</li>
                        <li>Supporting documents uploaded for assessment validation</li>
                    </ul>
                </p>
                <p className='ms-3'>
                    1.2 Technical Information:
                    <ul className='ms-4'>
                        <li>IP address and location data</li>
                        <li>Browser type and version</li>
                        <li>Operating system</li>
                        <li>Usage data and analytics</li>
                        <li>Cookies and similar tracking technologies</li>
                    </ul>
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    How We Use Your Information
                </h5>
                <p className='ms-3'>
                    2.1 Primary Uses:
                    <ul className='ms-4'>
                        <li>To provide and maintain the SME and Supplier ESG Readiness Tool</li>
                        <li>To process and evaluate your assessment submissions</li>
                        <li>To generate ESG maturity scores and reports</li>
                        <li>To communicate with you about your account and assessments</li>
                        <li>To provide technical support and assistance</li>
                    </ul>
                </p>
                <p className='ms-3'>
                    2.2 Secondary Uses:
                    <ul className='ms-4'>
                        <li>To improve the Tool's functionality and user experience</li>
                        <li>To conduct research and analysis (using aggregated data)</li>
                        <li>To comply with legal obligations</li>
                        <li>To prevent fraud and ensure security</li>
                    </ul>
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Data Storage and Security
                </h5>
                <p className='ms-3'>
                    3.1 Data Storage:
                    <ul className='ms-4'>
                        <li>Your data is stored on secure servers located in South Africa</li>
                        <li>We implement appropriate technical and organizational measures to protect your data</li>
                        <li>Regular security assessments and updates are performed</li>
                    </ul>
                </p>
                <p className='ms-3'>
                    3.2 Data Retention:
                    <ul className='ms-4'>
                        <li>We retain your data only for as long as necessary to fulfill the purposes outlined in this policy</li>
                        <li>Assessment data is retained for a minimum period of 5 years</li>
                        <li>You may request deletion of your data in accordance with applicable laws</li>
                    </ul>
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Data Sharing and Disclosure
                </h5>
                <p className='ms-3'>
                    4.1 We may share your information with:
                    <ul className='ms-4'>
                        <li>Service providers who assist in operating the Tool</li>
                        <li>Technical support teams for troubleshooting</li>
                        <li>Legal authorities when required by law</li>
                        <li>Research partners (using aggregated, anonymized data only)</li>
                    </ul>
                </p>
                <p className='ms-3'>
                    4.2 We do not sell your personal information to third parties.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Your Rights
                </h5>
                <p className='ms-3'>
                    Under POPIA, you have the right to:
                    <ul className='ms-4'>
                        <li>Access your personal information</li>
                        <li>Correct inaccurate or incomplete information</li>
                        <li>Request deletion of your information</li>
                        <li>Object to processing of your information</li>
                        <li>Request restriction of processing</li>
                        <li>Data portability</li>
                        <li>Withdraw consent at any time</li>
                    </ul>
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Cookies and Tracking
                </h5>
                <p className='ms-3'>
                    6.1 We use cookies and similar tracking technologies to:
                    <ul className='ms-4'>
                        <li>Maintain your session</li>
                        <li>Remember your preferences</li>
                        <li>Analyze usage patterns</li>
                        <li>Improve the Tool's performance</li>
                    </ul>
                </p>
                <p className='ms-3'>
                    6.2 You can control cookie settings through your browser preferences.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Children's Privacy
                </h5>
                <p className='ms-3'>
                    The Tool is not intended for use by individuals under 18 years of age. We do not knowingly collect personal information from children.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Changes to This Policy
                </h5>
                <p className='ms-3'>
                    We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.
                </p>
            </div>

            <div>
                <h5 className='text-primary'>
                    Contact Information
                </h5>
                <div className='ms-3'>
                    <p className='mb-2'>For privacy-related inquiries, please contact us at:</p>
                    <p className='ms-3 mb-1'>Email: info@globalcompactsa.org.za</p>
                    <p className='ms-3 mb-1'>Phone: +27 11 771 41 42</p>
                    <p className='ms-3 mb-3'>Address: 26 Melville Road, Johannesburg, South Africa</p>
                </div>
            </div>

            <div>
                <p className='fw-bold'>
                    By using the SME and Supplier ESG Readiness Tool, you acknowledge that you have read and understood this Privacy Policy.
                </p>
            </div>
        </Container>
    )
};

export default PrivacyPolicy 